<p-dialog
  [(visible)]="isVisible"
  [modal]="true"
  header="Créer un événement"
  [style]="{ width: '700px', maxHeight: '90vh' }"
  (onHide)="hide()"
  styleClass="compact-modal"
>
  <div class="p-fluid">
    <div
      class="mb-2"
      *ngIf="erpSource === '' && getSelectedTechniciansFromStorage().length > 0"
    >
      <h4 class="text-sm font-medium mb-2 text-red-400">
        Erreur: Vous avez sélectionné plusieurs techniciens ayant une entreprise
        différente.
      </h4>
    </div>
    <div class="mb-2" *ngIf="getSelectedTechniciansFromStorage().length === 0">
      <h4 class="text-sm font-medium mb-2 text-red-400">
        Erreur: Vous n'avez pas selectionné de techniciens.
      </h4>
    </div>

    <div *ngIf="erpSource !== ''">
      <form [formGroup]="form" (ngSubmit)="createEvenement()">
        <p-tabview styleClass="compact-tabs">
          <!-- Onglet Informations générales -->
          <p-tabpanel header="Informations générales">
            <div class="flex flex-col gap-3">
              <div class="flex flex-col">
                <label class="font-medium mb-1 text-sm">Utilisateur(s)*</label>
                <p-multiselect
                  [options]="allTechnicians"
                  optionLabel="fullName"
                  formControlName="users"
                  placeholder="Sélectionner les techniciens"
                  styleClass="w-full"
                ></p-multiselect>
              </div>

              <div class="flex flex-col">
                <label class="font-medium mb-1 text-sm"
                  >Type d'évènement*</label
                >
                <p-select
                  [options]="allEventTypes"
                  optionLabel="name"
                  formControlName="eventType"
                  styleClass="w-full"
                  [filter]="true"
                  (onChange)="setEventTypeName($event)"
                  appendTo="body"
                ></p-select>
              </div>

              <div class="flex flex-col">
                <label class="font-medium mb-1 text-sm">Nom*</label>
                <input type="text" pInputText formControlName="name" />
              </div>

              <div class="flex flex-col">
                <label class="font-medium mb-1 text-sm">Description</label>
                <textarea
                  pTextarea
                  rows="2"
                  placeholder="Facultatif : Description"
                  class="w-full"
                  formControlName="description"
                ></textarea>
              </div>

              <!-- Date/Time in row for space saving -->
              <div class="grid grid-cols-3 gap-2">
                <div class="flex flex-col">
                  <label class="font-medium mb-1 text-sm">Date et heure*</label>
                  <p-datepicker
                    [showTime]="true"
                    [showIcon]="true"
                    formControlName="startTime"
                    styleClass="w-full"
                    dateFormat="dd/mm/yy"
                    hourFormat="24"
                  ></p-datepicker>
                </div>

                <div class="flex flex-col">
                  <label class="font-medium mb-1 text-sm">Durée*</label>
                  <p-datepicker
                    formControlName="duration"
                    [timeOnly]="true"
                    styleClass="w-full"
                    hourFormat="24"
                    [showIcon]="true"
                  ></p-datepicker>
                </div>

                <div class="flex flex-col">
                  <label class="font-medium mb-1 text-sm">CP</label>
                  <input type="text" pInputText formControlName="postalCode" />
                </div>
              </div>

              <!-- Address fields in row -->
              <div class="grid grid-cols-2 gap-2">
                <div class="flex flex-col">
                  <label class="font-medium mb-1 text-sm">Adresse</label>
                  <input type="text" pInputText formControlName="address" />
                </div>
                <div class="flex flex-col">
                  <label class="font-medium mb-1 text-sm">Ville</label>
                  <input type="text" pInputText formControlName="locality" />
                </div>
              </div>
            </div>
          </p-tabpanel>

          <!-- Onglet Récurrence -->
          <p-tabpanel>
            <ng-template pTemplate="header">
              <span class="flex items-center gap-2">
                <i class="pi pi-refresh"></i>
                <span>Récurrence</span>
                <span
                  *ngIf="form.get('recurrenceEnabled')?.value"
                  class="bg-primary-500 text-white text-xs px-1.5 py-0.5 rounded-full"
                >
                  Activée
                </span>
              </span>
            </ng-template>

            <div class="flex flex-col gap-4">
              <!-- Activation de la récurrence -->
              <div
                class="flex items-center gap-3 p-3 rounded-lg bg-surface-100 dark:bg-surface-800"
              >
                <p-checkbox
                  formControlName="recurrenceEnabled"
                  [binary]="true"
                  inputId="recurrenceEnabled"
                ></p-checkbox>
                <label
                  for="recurrenceEnabled"
                  class="font-medium text-sm cursor-pointer"
                >
                  <i class="pi pi-refresh mr-2"></i>
                  Activer la récurrence pour cet événement
                </label>
              </div>

              <!-- Configuration de la récurrence -->
              <div
                *ngIf="form.get('recurrenceEnabled')?.value"
                class="space-y-4"
              >
                <!-- Intervalle de récurrence -->
                <div
                  class="border rounded-lg p-4 bg-primary-50 dark:bg-primary-900/20 border-primary-200 dark:border-primary-700"
                >
                  <h6
                    class="font-semibold text-sm mb-3 text-primary-800 dark:text-primary-200"
                  >
                    <i class="pi pi-clock mr-2"></i>
                    Fréquence
                  </h6>

                  <div class="flex items-center gap-3">
                    <span class="text-sm">Répéter tous les</span>
                    <p-inputNumber
                      [min]="1"
                      formControlName="recurrenceInterval"
                      [style]="{ width: '80px' }"
                    ></p-inputNumber>
                    <p-select
                      [options]="recurrenceUnits"
                      formControlName="recurrenceUnit"
                      placeholder="Unité"
                      optionLabel="label"
                      optionValue="value"
                      appendTo="body"
                      [style]="{ minWidth: '120px' }"
                    ></p-select>
                  </div>
                </div>

                <!-- Jours de la semaine -->
                <div
                  *ngIf="form.get('recurrenceUnit')?.value === 'week'"
                  class="border rounded-lg p-4 bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-700"
                >
                  <h6
                    class="font-semibold text-sm mb-3 text-blue-800 dark:text-blue-200"
                  >
                    <i class="pi pi-calendar mr-2"></i>
                    Jours de la semaine
                  </h6>

                  <div class="grid grid-cols-7 gap-2">
                    <p-toggle-button
                      *ngFor="let day of weekDays"
                      [onLabel]="day.label"
                      [offLabel]="day.label"
                      [(ngModel)]="day.selected"
                      (onChange)="toggleDay(day.value)"
                      [ngModelOptions]="{ standalone: true }"
                      styleClass="week-day-toggle"
                    >
                    </p-toggle-button>
                  </div>
                </div>

                <!-- Fin de récurrence -->
                <div
                  class="border rounded-lg p-4 bg-orange-50 dark:bg-orange-950/70 border-orange-200 dark:border-orange-500"
                >
                  <h6
                    class="font-semibold text-sm mb-3 text-orange-800 dark:text-orange-300"
                  >
                    <i class="pi pi-calendar-times mr-2"></i>
                    Fin de la récurrence
                  </h6>

                  <div class="space-y-3">
                    <div class="flex items-center gap-3">
                      <p-radiobutton
                        name="recurrenceEndType"
                        value="never"
                        formControlName="recurrenceEndType"
                        inputId="never"
                      ></p-radiobutton>
                      <label
                        for="never"
                        class="cursor-pointer text-gray-700 dark:text-gray-200"
                      >
                        Ne jamais finir
                      </label>
                    </div>

                    <div class="flex items-center gap-3">
                      <p-radiobutton
                        name="recurrenceEndType"
                        value="after"
                        formControlName="recurrenceEndType"
                        inputId="after"
                      ></p-radiobutton>
                      <label
                        for="after"
                        class="cursor-pointer text-gray-700 dark:text-gray-200"
                      >
                        Finir après
                      </label>
                      <p-inputnumber
                        *ngIf="form.get('recurrenceEndType')?.value === 'after'"
                        [min]="1"
                        formControlName="recurrenceEndAfter"
                        [style]="{ width: '80px' }"
                      ></p-inputnumber>
                      <span
                        *ngIf="form.get('recurrenceEndType')?.value === 'after'"
                        class="text-gray-700 dark:text-gray-200"
                      >
                        occurrences
                      </span>
                    </div>

                    <div class="flex items-center gap-3">
                      <p-radiobutton
                        name="recurrenceEndType"
                        value="until"
                        formControlName="recurrenceEndType"
                        inputId="until"
                      ></p-radiobutton>
                      <label
                        for="until"
                        class="cursor-pointer text-gray-700 dark:text-gray-200"
                      >
                        Finir le
                      </label>
                      <p-datepicker
                        *ngIf="form.get('recurrenceEndType')?.value === 'until'"
                        formControlName="recurrenceEndDate"
                        [showIcon]="true"
                        dateFormat="dd/mm/yy"
                        appendTo="body"
                        placeholder="Date de fin"
                        [style]="{ width: '150px' }"
                      ></p-datepicker>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Message informatif quand récurrence désactivée -->
              <div
                *ngIf="!form.get('recurrenceEnabled')?.value"
                class="text-center p-6 text-gray-500 dark:text-gray-400"
              >
                <i class="pi pi-info-circle text-2xl mb-2"></i>
                <p>
                  Activez la récurrence pour configurer la répétition de cet
                  événement
                </p>
              </div>
            </div>
          </p-tabpanel>
        </p-tabview>

        <div
          class="flex justify-end pt-4 border-t border-surface-200 dark:border-surface-700 mt-4"
        >
          <button
            type="submit"
            pButton
            class="p-button-success"
            [disabled]="submitting"
            [loading]="submitting"
          >
            <i class="pi pi-check mr-2" *ngIf="!submitting"></i>
            <span>{{
              submitting ? 'Création en cours...' : 'Créer l’événement'
            }}</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</p-dialog>
